'use client'

import dynamic from 'next/dynamic'

export const UserAuthDialogClient = dynamic(
  () => import('@repo/user-auth-dialog').then(mod => mod.UserAuthDialog),
  {
    ssr: false,
  },
)
